import { useLayoutEffect } from 'react';

function getHeight(testId: string): number {
  return (
    document.querySelector<HTMLElement>(`[data-testid="${testId}"]`)?.offsetHeight ?? 0
  );
}

/**
 * Хэдер и нижний бар — плавающие оверлеи (`position: absolute`) поверх
 * прокручиваемого контента, как в макете Figma (438:48164 «BETBOOM MAIN»):
 * `header`/`bottom_bar` там — те же инстансы поверх ленты карточек, не
 * отдельные строки в потоке. Контент должен уходить под них при скролле,
 * поэтому `.main` в AppLayout.module.scss занимает весь холст, а не только
 * место между ними — иначе скруглённый угол хэдера/бара показывал бы
 * пустой фон холста, а не карточку, которая сейчас под ним.
 *
 * Паддинг `.main` под их реальную высоту — иначе первая/последняя карточка
 * навсегда пряталась бы под ними, а не только при скролле до самого верха/низа.
 */
export function useOverlayOffsets(): void {
  useLayoutEffect(() => {
    const apply = (): void => {
      const root = document.documentElement.style;
      root.setProperty('--header-h', `${String(getHeight('app-header'))}px`);
      root.setProperty('--bottom-bar-h', `${String(getHeight('bottom-bar'))}px`);
    };
    apply();

    const header = document.querySelector('[data-testid="app-header"]');
    const bottomBar = document.querySelector('[data-testid="bottom-bar"]');
    const observer = new ResizeObserver(apply);
    if (header) observer.observe(header);
    if (bottomBar) observer.observe(bottomBar);

    return () => {
      observer.disconnect();
    };
  }, []);
}
